import React from "react";
import COLORS from "../../../../colors";
import "../styles/index.scss";

export default function CloseLargeIcon({
  className = "",
  fill = COLORS.TERTIARY_COLOR_0,
  ...props
}) {
  return (
    <React.Fragment>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`close-icon-new ${className}`}
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17 4.41421L11.4142 9.99997L17 15.5858L15.5858 17L10 11.4142L4.41421 17L3 15.5858L8.58581 9.99997L3 4.41416L4.41421 2.99995L10 8.58576L15.5858 3L17 4.41421Z"
          fill={fill}
        />
      </svg>
    </React.Fragment>
  );
}
